<template>

  <div>

    <div class="bg-white">
      <br class="d-none d-lg-block">
    	<br>
    	<div class="container py-1">
    	  <br class="d-none d-md-block">
    	  <div class="row">
    	    <div class="col-md-6">
            <p class="small grey text-uppercase mb-2"><a href="/trailer-rental">{{`Trailer Rental in ${countriesStr('and')}`}}</a>:</p>
    	      <h1 class="h2">Container Chassis Trailer Rental</h1>
    	      <p class="lead grey">Rent a Container Chassis Trailer with <strong>PNO Rental</strong> for your next transportation need.</p>
    				<hr>
    				<p class="text-lg d-none d-sm-block">Find a Container Chassis Trailer that fit your transportation needs. Simply request your Container Chassis Trailer available for short-term rental with PNO Rental.</p>
    				<p><a href="/trailers?category=container" class="btn btn-lg btn-success">Search Container Chassis Trailers <i class="fa fa-chevron-right ml-1"></i></a></p>
    	    </div>
            <div class="col-md-6 col-xl-5 offset-xl-1">
                <img :src="require('@/assets/img/type_container-chassis.jpg')" class="img-fluid mb-3" alt="Container Chassis Trailer Rental">
          </div>
    	  </div>
    	</div>
    	<br class="d-none d-md-block">
    </div>

    <div class="container py-4">
    	<br class="d-none d-md-block">
    	<h2 class="h4">Container Chassis Trailer Features</h2>
    	<p class="lead grey">Container chassis are the most common choice for container movement.</p>
    	<hr>
    	<br>
    	<div class="row">
    	  <div class="col-md-4">
    			<h5>Standard</h5>
    			<p class="grey">Straight frame for transportation of standard containers.</p>
    	  </div>
    	  <div class="col-md-4">
    			<h5>Gooseneck</h5>
    			<p class="grey">Gooseneck frame for transportation of high cube containers within Europe.</p>
    			<br class="d-none d-md-block">
    	  </div>
    	  <div class="col-md-4">
    			<h5>Multiple</h5>
    			<p class="grey">Multiple specification for transportation of different combinations of container types.</p>
    	  </div>
    	</div>
        <hr>
    	<p class="small grey">The specifications listed are based upon PNO's most commonly rented trailers. They are not the exact measurements of all trailers rented by PNO. Specifications will vary by make, model and year of trailer.</p>
    </div>
  
  	<pno-how />

  	<pno-prompt />

  </div>

</template>

<script>
import PnoHow from '@/components/PnoHow.vue'
import PnoPrompt from '@/components/PnoPrompt.vue'
import { countriesStr } from '@/assets/countries';

export default {
	methods: {
		countriesStr
	},
    mounted() {
        this.$store.commit('meta/title', 'Container Chassis Trailer for Short-term Rental')
        this.$store.commit('meta/description', 'Rent a Container Chassis Trailer with PNO Rental for your next transportation need. Get your quote today!')
        this.$store.commit('meta/image', this.generateSmartImgUrl(require('@/assets/img/type_container-chassis.jpg') , 'ogimage'));
    },
	components: { PnoHow, PnoPrompt },
}
</script>
